export const VACATION_TYPE_LENGTH = 15;
export const EMPLOYEE_NAME_MAX_LENGTH = 15;
export const DAY_POSITION_DIVIDER = 15;
export const TIMEOFF_SUBMIT_SUCCESS_MESSAGE = 'Request was submitted successfully.';
export const INCREMENT_MAX_MONTH = 'December';
export const DECREMENT_MIN_MONTH = 'January';
export const DATE_FILTER_CRITERIA = 'month';
export const enum VacationTypes {
    PAID_VACATION = 'Paid Vacation',
    UNPAID_VACATION = 'Unpaid Vacation',
    PAID_VACATION_BONUS_DAYS = 'Paid Vacation - Bonus Days',
}
export const MAX_DATE_MONTH_VALUE = 11;
export const MAX_DATE_DAY_VALUE = 31;
export const USE_BONUS_DAYS_BEFORE_BASE_PAID_DAYS_ERROR_MESSAGE = 'All base paid days must be used before requesting bonus paid days.';
export const REQUESTED_VACATION_EXCEEDING_AVAILABLE_VACATION_DAYS_ERROR_MESSAGE = 'Requested vacation days are exceeding available vacation days';